import { z } from 'zod';

export const lockingSchema = z.object({
  isLocked: z.boolean({}).optional(),
});
